/**
 * The search service authenticates with the user's Hallow JWT (added by
 * `getRequestHeaders` when a session token exists) and treats a request with
 * no Authorization header as a guest. It must never receive the legacy Elastic
 * search key, which it would reject as an invalid JWT.
 */
export const HEADERS_SEARCH_SERVICE: HeadersInit = {
  "Content-Type": "application/json",
};
